import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const SingleProject = () => {
    const { id } = useParams();
    console.log(id);

    const project1 = {
        "_id": 1,
        "img1": "https://i.ibb.co/XtbF8wR/images.jpg",
        "img2": "https://i.ibb.co/qjDVNbG/img2.png",
        "img3": "https://i.ibb.co/sFNctW7/img3.png",
        "img4": "https://i.ibb.co/7R0ZPw3/img4.png",
        "img5": "https://i.ibb.co/CwR0sJ8/img5.png",
        "img6": "https://i.ibb.co/Zc11dTW/img6.png",
        "name": "Manufacturer Company",
        "live": "https://manufacturer-company-96a22.web.app/",
        "client": "https://github.com/fazriislam/manufacturer-company-client-side-a12",
        "server": "https://github.com/fazriislam/manufacturer-company-server-side-12"
    };

    const project2 = {
        "_id": 2,
        "img1": "https://i.ibb.co/k9ZRW8X/banner3.jpg",
        "img2": "https://i.ibb.co/9Npystf/img2.png",
        "img3": "https://i.ibb.co/sgZZyF7/img3.png",
        "img4": "https://i.ibb.co/sV1dNhN/img4.png",
        "img5": "https://i.ibb.co/6rZVWWw/img5.png",
        "img6": "https://i.ibb.co/Sdpnxh2/img6.png",
        "name": "Warehouse Management",
        "live": "https://warehouse-98797.web.app/",
        "client": "https://github.com/fazriislam/warehouse-management-client-side-a11",
        "server": "https://github.com/fazriislam/warehouse-management-server-side-a11"
    };

    const project3 = {
        "_id": 3,
        "img1": "https://i.ibb.co/PwYCzSN/img1.png",
        "img2": "https://i.ibb.co/PxFSqP9/img2.png",
        "img3": "https://i.ibb.co/3prqqsq/img3.png",
        "name": "Generous Travel Guide",
        "live": "https://travel-guide-fd1e9.web.app/",
        "client": "https://github.com/fazriislam/generous-travel-guide-a10",
        "server": null
    }

    return (
        < div className='bg-accent'>
            {id == 1 && <>
                <h2 className='text-3xl font-bold'>Some Photos of {project1.name}</h2>
                <div className='lg:w-10/12 grid lg:grid-cols-3 lg:gap-5 grid-cols-1 mx-auto lg:mt-10'>
                    <img className='w-full' src={project1.img1} alt="Album" />
                    <img src={project1.img2} alt="Album" />
                    <img src={project1.img3} alt="Album" />
                    <img src={project1.img4} alt="Album" />
                    <img src={project1.img5} alt="Album" />
                    <img src={project1.img6} alt="Album" />
                </div>
                <div className='lg:mt-10'>
                    <div style={{ height: '3px' }} className='bg-black w-1/2 mx-auto'></div>
                    <p className='text-2xl font-bold'>Project Name: {project1.name}</p>
                    <div>
                        <a href={project1.live} target='_blank'>Live Site</a><span className='font-bold mx-1'>||</span>
                        <a href={project1.client} target='_blank'>GitHub Client</a>
                        <span className='font-bold mx-1'>||</span>
                        <a href={project1.server} target='_blank'>GitHub Server</a>
                    </div>
                    <div>
                        <p className='text-xl font-semibold'>Project Descriptions:</p>
                        <ul className='lg:list-disc'>
                            <li>Responsive SPA for a Manufacturer Company.</li>
                            <li>Authentication & Authorization developed with Firebase & JWT.</li>
                            <li>Stripe is used as a payment gateway.</li>
                            <li>Implement Different Route for Admins and Normal Users</li>
                            <li>Used DaisyUI as TailWindCSS Component</li>
                            <p><strong>Technology:</strong> React, Node.JS, Express, Firebase, Stripe, Tailwind, DaisyUI, MongoDB.</p>
                        </ul>
                    </div>
                </div>

            </>
            }

            {/* Second One */}
            {id == 2 && <>
                <h2 className='text-3xl font-bold'>Some Photos of {project2.name}</h2>
                <div className='lg:w-10/12 grid lg:grid-cols-3 lg:gap-5 grid-cols-1 mx-auto lg:mt-10'>
                    <img className='w-full' src={project2.img1} alt="Album" />
                    <img src={project2.img2} alt="Album" />
                    <img src={project2.img3} alt="Album" />
                    <img src={project2.img4} alt="Album" />
                    <img src={project2.img5} alt="Album" />
                    <img src={project2.img6} alt="Album" />
                </div>
                <div className='lg:mt-10'>
                    <div style={{ height: '3px' }} className='bg-black w-1/2 mx-auto'></div>
                    <p className='text-2xl font-bold'>Project Name: {project2.name}</p>
                    <div>
                        <a href={project2.live} target='_blank'>Live Site</a><span className='font-bold mx-1'>||</span>
                        <a href={project2.client} target='_blank'>GitHub Client</a>
                        <span className='font-bold mx-1'>||</span>
                        <a href={project2.server} target='_blank'>GitHub Server</a>
                    </div>
                    <div>
                        <p className='text-xl font-semibold'>Project Descriptions:</p>
                        <ul className='lg:list-disc'>
                            <li>Responsive SPA Application with Attractive Design.</li>
                            <li>Firebase Implemented to ensure Authentication.</li>
                            <li>MongoDB used to manage databases.</li>
                            <li>Authorization Method Implemented with JWT Token</li>
                            <li>TailwindCSS used as CSS Framework.</li>
                            <p><strong>Technology:</strong> React, Firebase, Node.JS, Express,
                                Tailwind, MongoDB.
                            </p>
                        </ul>
                    </div>
                </div>

            </>
            }

            {/* Third One */}
            {id == 3 && <>
                <h2 className='text-3xl font-bold'>Some Photos of {project3.name}</h2>
                <div className='lg:w-10/12 grid lg:grid-cols-3 lg:gap-5 grid-cols-1 mx-auto lg:mt-10'>
                    <img className='w-full' src={project3.img1} alt="Album" />
                    <img src={project3.img2} alt="Album" />
                    <img src={project3.img3} alt="Album" />
                </div>
                <div className='lg:mt-10'>
                    <div style={{ height: '3px' }} className='bg-black w-1/2 mx-auto'></div>
                    <p className='text-2xl font-bold'>Project Name: {project3.name}</p>
                    <div>
                        <a href={project3.live} target='_blank'>Live Site</a><span className='font-bold mx-1'>||</span>
                        <a href={project3.client} target='_blank'>GitHub Client</a>
                        <span className='font-bold mx-1'>||</span>
                        <a href={project3.server} target='_blank'>GitHub Server</a>
                    </div>
                    <div>
                        <p className='text-xl font-semibold'>Project Descriptions:</p>
                        <ul className='lg:list-disc'>
                            <li>Responsive SPA for an Independent Travel Guide</li>
                            <li>Used React Considering User Experience.</li>
                            <li>Firebase Implemented to ensure Authentication.</li>
                            <li>Easy Booking Method</li>
                            <li>Gathered Best Places around the world</li>
                            <p><strong>Technology:</strong> React, Firebase, Bootstrap, Custom Hooks.
                            </p>
                        </ul>
                    </div>
                </div>

            </>
            }

        </div >
    );
};

export default SingleProject;